/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetActiveDeploymentSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetActiveDeploymentSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetActiveDeploymentSecurity = {
  option1?: GetActiveDeploymentSecurityOption1 | undefined;
  option2?: GetActiveDeploymentSecurityOption2 | undefined;
};

export type GetActiveDeploymentRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetActiveDeploymentSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetActiveDeploymentSecurityOption1$outboundSchema: z.ZodMiniType<
  GetActiveDeploymentSecurityOption1$Outbound,
  GetActiveDeploymentSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getActiveDeploymentSecurityOption1ToJSON(
  getActiveDeploymentSecurityOption1: GetActiveDeploymentSecurityOption1,
): string {
  return JSON.stringify(
    GetActiveDeploymentSecurityOption1$outboundSchema.parse(
      getActiveDeploymentSecurityOption1,
    ),
  );
}

/** @internal */
export type GetActiveDeploymentSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetActiveDeploymentSecurityOption2$outboundSchema: z.ZodMiniType<
  GetActiveDeploymentSecurityOption2$Outbound,
  GetActiveDeploymentSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getActiveDeploymentSecurityOption2ToJSON(
  getActiveDeploymentSecurityOption2: GetActiveDeploymentSecurityOption2,
): string {
  return JSON.stringify(
    GetActiveDeploymentSecurityOption2$outboundSchema.parse(
      getActiveDeploymentSecurityOption2,
    ),
  );
}

/** @internal */
export type GetActiveDeploymentSecurity$Outbound = {
  Option1?: GetActiveDeploymentSecurityOption1$Outbound | undefined;
  Option2?: GetActiveDeploymentSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetActiveDeploymentSecurity$outboundSchema: z.ZodMiniType<
  GetActiveDeploymentSecurity$Outbound,
  GetActiveDeploymentSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetActiveDeploymentSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetActiveDeploymentSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getActiveDeploymentSecurityToJSON(
  getActiveDeploymentSecurity: GetActiveDeploymentSecurity,
): string {
  return JSON.stringify(
    GetActiveDeploymentSecurity$outboundSchema.parse(
      getActiveDeploymentSecurity,
    ),
  );
}

/** @internal */
export type GetActiveDeploymentRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetActiveDeploymentRequest$outboundSchema: z.ZodMiniType<
  GetActiveDeploymentRequest$Outbound,
  GetActiveDeploymentRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getActiveDeploymentRequestToJSON(
  getActiveDeploymentRequest: GetActiveDeploymentRequest,
): string {
  return JSON.stringify(
    GetActiveDeploymentRequest$outboundSchema.parse(getActiveDeploymentRequest),
  );
}
